<template>
  <!-- 公共的筛选校区组件。示例如下 -->
  <!--1.可以编辑的 <select-school :schObj="schObj" @changeVal="getVal"></select-school> -->
  <!--2.仅仅展示的 <select-school :schObj="schObj" :canUse="canUse"></select-school> -->
  <div id="selectSch">
    <el-form-item
      label="适用学校："
      prop="schObj.applicableCampus"
      v-if="canUse"
    >
      <el-radio :disabled="disabled" v-model="schObj.applicableCampus" label="0"
        >全部</el-radio
      >
      <el-radio :disabled="disabled" v-model="schObj.applicableCampus" label="1"
        >部分</el-radio
      >
    </el-form-item>
    <el-form-item
      label="适用学校："
      prop="schObj.applicableCampus"
      v-if="!canUse"
    >
      <el-radio
        :disabled="disabled"
        v-if="schObj.applicableCampus == '0'"
        v-model="schObj.applicableCampus"
        label="0"
        disabled
        >全部</el-radio
      >
      <el-radio
        :disabled="disabled"
        v-if="schObj.applicableCampus == '1'"
        v-model="schObj.applicableCampus"
        label="1"
        disabled
        >部分</el-radio
      >
    </el-form-item>
    <el-form-item label="屏蔽学校：" v-if="schObj.applicableCampus == '0'">
      <el-select
        :disabled="disabled"
        v-model="campus"
        filterable
        v-if="schObj.applicableCampus == '0' && canUse"
        placeholder="请选择"
        class="inline"
      >
        <el-option
          v-for="(item, index) in options"
          :value="item.rootUnid"
          :label="item.name"
          :key="index"
        ></el-option>
      </el-select>
      <el-button
        :disabled="disabled"
        class="inline"
        type="primary"
        v-if="schObj.applicableCampus === '0' && canUse"
        @click="addCamp(0)"
        >添加</el-button
      >
      <div
        :style="{ 'pointer-events': disabled ? 'none' : '' }"
        v-if="schObj.applicableCampus === '0'"
        class="campContain"
      >
        <span
          v-for="(item, index) in schObj.shieldedSchools"
          v-if="item.name"
          class="campSpan"
          :key="index"
          >{{ item.name }}
          <i
            @click="deleteShieldedCamp(index)"
            class="el-icon-circle-close"
            v-if="canUse"
          ></i>
        </span>
      </div>
      <span>一共 {{ schObj.shieldedSchools.length }} 所学校</span>
    </el-form-item>

    <el-form-item
      label="应用学校："
      v-if="schObj.applicableCampus == '1'"
      required
    >
      <el-select
        :disabled="disabled"
        v-model="campus"
        filterable
        v-if="schObj.applicableCampus == '1' && canUse"
        placeholder="请选择"
        class="inline"
      >
        <el-option
          v-for="(item, index) in options"
          v-if="item.rootUnid !== 0"
          :value="item.rootUnid"
          :label="item.name"
          :key="index"
        ></el-option>
      </el-select>
      <el-button
        :disabled="disabled"
        class="inline"
        type="primary"
        v-if="schObj.applicableCampus === '1' && canUse"
        @click="addCamp(1)"
        >添加</el-button
      >
      <div
        :style="{ 'pointer-events': disabled ? 'none' : '' }"
        v-if="schObj.applicableCampus === '1'"
        class="campContain"
      >
        <span
          v-for="(item, index) in schObj.openedSchools"
          v-if="item.name"
          class="campSpan"
          :key="index"
          >{{ item.name }}
          <i
            @click="deleteOpenedCamp(index)"
            class="el-icon-circle-close"
            v-if="canUse"
          ></i>
        </span>
      </div>
      <span>一共 {{ schObj.openedSchools.length }} 所学校</span>
    </el-form-item>
  </div>
</template>

<script>
export default {
  data() {
    return {
      campus: "",
      options: [],
    };
  },
  props: {
    schObj: {
      type: Object,
    },
    canUse: {
      type: Boolean,
      default: true,
    },
    //isRoot,true:筛选学校；false:筛选校区；
    isRoot: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    schObj: {
      handler(curVal, oldVal) {
        if (this.canUse) this.$emit("changeVal", curVal);
      },
      deep: true,
    },
  },

  mounted() {
    if (this.canUse) {
      this.getschoolandunid();
    }
  },
  methods: {
    //获取所有校区信息
    getschoolandunid() {
      let url =
        this.$util.domain +
        (this.isRoot
          ? "/adminapi/v1/basicTools/allSchools"
          : "/adminapi/v1/basicTools/allCampusZones");

      this.$http({
        url,
        method: "GET",
      }).then((response) => {
        if (response.body.data && response.body.data.length) {
          if (this.isRoot) response.body.data.shift();
          response.body.data.forEach((item) => {
            this.options.push({
              name: item.name,
              rootUnid: this.isRoot ? item.rootUnid : item.unid,
            });
          });
        }
      });
    },
    //向文本框中添加校区
    addCamp(num) {
      let name,
        rootUnid = this.campus;
      this.campus = "";
      for (let i = 0; i < this.options.length; i++) {
        if (rootUnid == this.options[i].rootUnid) name = this.options[i].name;
      }
      if (num == 0) {
        for (let i = 0; i < this.schObj.shieldedSchools.length; i++) {
          if (name == this.schObj.shieldedSchools[i].name) return false;
        }
        if (name)
          this.schObj.shieldedSchools.push({ name, rootUnid: rootUnid * 1 });
      } else {
        for (let i = 0; i < this.schObj.openedSchools.length; i++) {
          if (name == this.schObj.openedSchools[i].name) return false;
        }
        if (name)
          this.schObj.openedSchools.push({ name, rootUnid: rootUnid * 1 });
      }
    },
    //删除文本框中校区
    deleteShieldedCamp(index) {
      this.schObj.shieldedSchools.splice(index, 1);
    },
    deleteOpenedCamp(index) {
      this.schObj.openedSchools.splice(index, 1);
    },
  },
};
</script>

<style scoped>
#selectSch .campContain {
  width: 500px;
  height: 135px;
  border: solid 1px gray;
  box-sizing: border-box;
  overflow-y: scroll;
}

#selectSch .campSpan {
  display: block;
  text-align: center;
  float: left;
  height: 36px;
  padding: 0 30px 5px 15px;
  border: solid 1px #999;
  border-radius: 5px;
  margin: 10px;
  box-sizing: border-box;
  font-size: 12px;
  position: relative;
  cursor: pointer;
}

#selectSch .campSpan i {
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #999;
  position: absolute;
  right: 5px;
  top: 5px;
}

#selectSch .el-radio {
  width: auto;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// selectSch.vue?52a2bd6c